<script setup lang="ts" generic="K extends string">
defineProps<{ items: ReadonlyArray<{ key: K; label: string; count?: number | string }>; label: string }>()

const model = defineModel<K>({ required: true })
</script>

<template>
  <div role="tablist" :aria-label="label" class="ui-tabs">
    <button
      v-for="item in items"
      :key="item.key"
      type="button"
      role="tab"
      class="ui-tabs__tab"
      :class="{ 'ui-tabs__tab--active': model === item.key }"
      :aria-selected="model === item.key"
      @click="model = item.key"
    >
      {{ item.label }}
      <span v-if="item.count !== undefined" class="ui-tabs__count">{{ item.count }}</span>
    </button>
  </div>
</template>

<style scoped>
.ui-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--separator);
  overflow-x: auto;
  overflow-y: hidden;
}
.ui-tabs__tab {
  height: var(--control-height);
  padding: 0 12px;
  border: none;
  background: transparent;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  color: var(--text-secondary);
  font: inherit;
  font-size: var(--type-body-size);
  font-weight: var(--weight-medium);
  cursor: pointer;
  white-space: nowrap;
  transition: color var(--duration-fast) var(--ease-standard);
}
.ui-tabs__tab:hover {
  color: var(--text-primary);
}
.ui-tabs__tab--active {
  border-bottom-color: var(--accent);
  color: var(--text-primary);
}
.ui-tabs__count {
  margin-left: 2px;
  color: var(--tertiary-label);
  font-weight: var(--weight-medium);
}
</style>
